import React from 'react';
import NoDataMsg from 'library/noData';
import moment from 'moment';
import { getDollarFormat } from 'utils/helpers';

const Body = ({ combinedSales, beginDate, endDate }) => (
    <div>
        {
            combinedSales.length <= 0 ?
                //If there's NO DATA to display
                <NoDataMsg />
                :
                //If there's DATA
                <div>
                    <div className="clearfix">
                        <div className="table-responsive">

                            <div className="row m-0">
                                <div className="text-center list_header">
                                    {beginDate ?
                                        <p><i>From</i> <b>{moment(beginDate).format('MMMM Do, YYYY')}</b> <i> to </i>
                                            {endDate ? <b>{moment(endDate).format('MMMM Do, YYYY')}</b> : moment().format('MMMM Do, YYYY')}</p>
                                        : ""}
                                </div>
                            </div>
                            {
                                combinedSales && combinedSales.list && combinedSales.list.length > 0 && combinedSales.list.map((item, index) => {
                                    return (
                                        <div className="row m-0 mb-1" key={index}>
                                            <div className="col-lg-12 title_th">
                                                <h3 className="m-0">{moment(item.date).format('MMMM Do, YYYY')} - {item.numberTransactions} Transaction{item.numberTransactions > 1 ? "s" : ""}</h3>
                                            </div>{/* row - Date */}

                                            <div className="col-lg-2 col-md-2 col-sm-4 col-xs-4 text-center">
                                                <label>Gross Sales</label>
                                                <h3 className="m-0 purpleText">{getDollarFormat(item.grossSales)}</h3>
                                            </div> {/* Column Orders */}
                                            <div className="col-lg-2 col-md-2 col-sm-4 col-xs-4 text-center">
                                                <label>Net Sales</label>
                                                <h3 className="m-0 purpleText">{getDollarFormat(item.netSales)}</h3>
                                            </div> {/* Column Orders */}
                                            <div className="col-lg-2 col-md-2 col-sm-4 col-xs-4 text-center">
                                                <label>Total Tax</label>
                                                <h3 className="m-0 purpleText">{getDollarFormat(item.totalTax)}</h3>
                                            </div> {/* Column Orders */}
                                            <div className="col-lg-2 col-md-2 col-sm-4 col-xs-4 text-center">
                                                <label>Discount</label>
                                                <h3 className="m-0 purpleText">{getDollarFormat(item.discount)}</h3>
                                            </div> {/* Column Orders */}
                                            <div className="col-lg-2 col-md-2 col-sm-4 col-xs-4 text-center">
                                                <label>Gross Profit</label>
                                                <h3 className="m-0 purpleText">{getDollarFormat(item.grossprofit)}</h3>
                                            </div> {/* Column Orders */}
                                            <div className="col-lg-2 col-md-2 col-sm-4 col-xs-4 text-center">
                                                <label>Average Transaction</label>
                                                <h3 className="m-0 purpleText">{getDollarFormat(item.averageTransaction)}</h3>
                                            </div> {/* Column Orders */}
                                            <div className="col-lg-2 col-md-2 col-sm-4 col-xs-4 text-center mt-1">
                                                <label>Total Refund Amount (Non-Including Tax)</label>
                                                <h3 className="m-0 purpleText">{getDollarFormat(item.refunds)}</h3>
                                            </div> {/* Column Orders */}
                                            <br />
                                            <div className="col-lg-2 col-md-2 col-sm-4 col-xs-4 text-center mt-1">
                                                <label>Total Deposit Amount</label>
                                                <h3 className="m-0 purpleText">{getDollarFormat(item.deposits)}</h3>
                                            </div> {/* Column Orders */}
                                            <div className="col-lg-2 col-md-2 col-sm-4 col-xs-4 text-center mt-1">
                                                <label>Total Gift Card Sales</label>
                                                <h3 className="m-0 purpleText">{getDollarFormat(item.giftCardSales)}</h3>
                                            </div> {/* Column Orders */}
                                            <div className="col-lg-2 col-md-2 col-sm-4 col-xs-4 text-center mt-1">
                                                <label>Total Gift Card Refund Amount</label>
                                                <h3 className="m-0 purpleText">{getDollarFormat(item.giftCardRefunds)}</h3>
                                            </div> {/* Column Orders */}
                                            <div className="col-lg-2 col-md-2 col-sm-4 col-xs-4 text-center mt-1">
                                                <label>Total Gift Card Discount Amount</label>
                                                <h3 className="m-0 purpleText">{getDollarFormat(item.giftCardDiscounts)}</h3>
                                            </div> {/* Column Orders */}
                                        </div>
                                    );
                                })
                            }

                        </div>

                    </div>
                </div>
        }
    </div>
);

export default Body;


